import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  element: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const CardElementConfiguration = ({ className, element }) => {
  const classes = classNames({
    'card-element-configuration': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <h3 className="card-element-configuration-type">{element.type}</h3>

      <pre className="card-element-configuration-metadata">
        <p>z-index: {element.z_index}</p>
      </pre>
    </div>
  );
};

CardElementConfiguration.propTypes = propTypes;

export default CardElementConfiguration;
